module.exports = __webpack_public_path__ + "static/img/14000056.373fb009.png";